document.addEventListener('DOMContentLoaded', () => {
    const videoContainers = document.querySelectorAll('[data-vimeo-container]');

    if (!videoContainers.length) {
        return;
    }

    for (const container of videoContainers) {
        const playButton = container.querySelector('[data-play]');
        const pauseButton = container.querySelector('[data-pause]');
        const player = new Vimeo.Player(
            container.querySelector('[data-video]')
        );

        player.on('ended', () => stopMedia(player, container));
        playButton.addEventListener('click', () =>
            playPauseMedia(player, container, true)
        );
        pauseButton.addEventListener('click', () =>
            playPauseMedia(player, container, false)
        );
    }

    function playPauseMedia(player, container, isPlaying) {
        player.getPaused().then(status => {
            if (isPlaying && status) {
                console.log(container);
                container.setAttribute('data-video-status', 'playing');
                player.play();
            } else if (!isPlaying && !status) {
                container.setAttribute('data-video-status', 'paused');
                player.pause();
            }
        });
    }

    function stopMedia(player, container) {
        player.pause().then(() => {
            player.setCurrentTime(0).then(() => {
                container.setAttribute('data-video-status', 'stopped');
            });
        });
    }
});
